async function postData(url = '', data = {}) {
  // Default options are marked with *
  let formBody = []
  for (let d in data) {
    const encodedKey = encodeURIComponent(d)
    const encodedValue = encodeURIComponent(data[d])
    formBody.push(encodedKey + '=' + encodedValue)
  }
  formBody = formBody.join('&')

  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: formBody// body data type must match 'Content-Type' header
  })
  return response.ok // parses JSON response into native JavaScript objects
}
class FormBehavior {
  constructor(el, submitCb) {
    this.el = el
    this.submitButton = this.el.querySelector('.webform-button--submit')
    const requiredTextField = this.el.querySelector('.js-form-item-required-field-text')
    // hidden fields
    const formTokenField = this.el.querySelector('[name=form_token]')
    const formBuildIdField = this.el.querySelector('[name=form_build_id]')
    const formIdField = this.el.querySelector('[name=form_id]')

    this.data = {
      'op': 'Submit',
      'form_token': formTokenField !== null ? formTokenField.value : '',
      'form_build_id': formBuildIdField !== null ? formBuildIdField.value : '',
      'form_id': formIdField !== null ? formIdField.value : ''
    }
    // Add error classes for invalid field
    this.fields = this.el.querySelectorAll('.js-form-item')
    this.submitCb = submitCb

    this.fields.forEach((field) => {
      const input = field.querySelector('input, select, textarea')

      if (input === null) return

      input.addEventListener('change', () => {
        this.data[input.name] = input.value

        if (!input.validity.valid) {
          field.classList.add('error')
          field.setAttribute('data-webform-required-error', input.getAttribute('data-webform-required-error'))
        } else {
          field.classList.remove('error')
        }
        // checks the forms validity everytime an input changes to bold 'all above fields required' text and color it red'
        if (!this.el.checkValidity()) {
          if (requiredTextField !== null) {
            requiredTextField.classList.add('error')
          }
          this.submitButton.classList.add('disabled')
        } else {
          this.submitButton.classList.remove('disabled')

          if (requiredTextField !== null) {
            requiredTextField.classList.remove('error')
          }
        }
      })
    })
    // Add submitted class if it was already tried once
    this.submitButton.addEventListener('click', () => {
      this.checkValidity()
      this.el.classList.add('submitted')
    })
    this.el.addEventListener('submit', (e) => {
      e.preventDefault()
      // console.log('submitted!!!')
      // console.dir(this.data)

      postData(document.location.pathname, this.data).then((responseIsOk) => {
        if (!responseIsOk) {
          console.error('Something went wrong with the form submission.')
        }
        // show thank you message
        if (typeof this.submitCb === 'function') {
          this.submitCb()
          const event = new CustomEvent('contactformsubmitted')
          document.dispatchEvent(event)
        }
      })
    })
  }

  checkValidity() {
    this.fields = this.el.querySelectorAll('.js-form-item')
    const requiredTextField = this.el.querySelector('.js-form-item-required-field-text')

    this.fields.forEach((field) => {
      const input = field.querySelector('input, select, textarea')

      if (input ===  null) return

      if (!input.validity.valid) {
        field.classList.add('error')
        field.setAttribute('data-webform-required-error', input.getAttribute('data-webform-required-error'))
      } else {
        field.classList.remove('error')
      }
      // checks the forms validity everytime an input changes to bold 'all above fields required' text and color it red"
      if (!this.el.checkValidity()) {
        if (requiredTextField !== null) {
          requiredTextField.classList.add('error')
        }
        this.submitButton.classList.add('disabled')
      } else {
        this.submitButton.classList.remove('disabled')

        if (requiredTextField !== null) {
          requiredTextField.classList.remove('error')
        }
      }
    })
  }
}


export default FormBehavior



// WEBPACK FOOTER //
// ./js/classes/form-behavior.class.js